var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.Hs=require("ttag");module.exports=$CLJS.Hs;